<template>
  <svg
    class="absolute inset-0 h-full w-full -rotate-90"
    :class="$attrs.class"
    viewBox="0 0 32 32"
    aria-hidden="true"
  >
    <circle
      class="text-black-200"
      cx="16"
      cy="16"
      :r="radius ?? 14"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
    />
    <circle
      class="text-black-600"
      cx="16"
      cy="16"
      :r="radius ?? 14"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      :stroke-dasharray="circumference"
      :stroke-dashoffset="dashOffset"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    /** Progress 0–100 */
    progress: number
    /** Circle radius in viewBox units (default 14) */
    radius?: number
  }>(),
  { radius: 14 },
)

const circumference = computed(() => 2 * Math.PI * props.radius)
const dashOffset = computed(() => circumference.value * (1 - props.progress / 100))
</script>
